import { useEffect, useState } from 'react'

import clientAxios from '../config/axios'

const useArea = () => {
  const [areas, setAreas] = useState([])

  useEffect(() => {
    const consultApi = async () => {
      await clientAxios
        .get('/geo-area/all')
        .then((response) => {
          setAreas(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    }

    consultApi()
  }, [])

  return [areas]
}

export default useArea
